module.exports = __webpack_public_path__ + "img/avatar6.9c16bc69.png";